import React from 'react';
import { useDarkClasses } from '../hooks/useDarkClasses';
import { CheckCircleIcon } from 'lucide-react';
const Accessibility = () => {
  const dk = useDarkClasses();
  return <div className={`min-h-screen ${dk.isDark ? 'bg-gray-900 text-gray-100' : 'bg-gray-50 text-gray-900'} py-12`} data-id="element-4214" data-mp="2iodo1eey6qqq">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4215" data-mp="2dxf3g2mxf6ho">
        <h1 className="text-3xl font-bold mb-6" data-id="element-4216" data-mp="2dvucso3qg7p3">Accessibility Statement</h1>

        <div className={`prose ${dk.isDark ? 'prose-invert' : ''} max-w-none`} data-id="element-4217" data-mp="2skqhcb6kz2ky">
          <p className="lead text-lg mb-8" data-id="element-4218" data-mp="2nmoztuoszbbl">
            LitLaunch is committed to ensuring digital accessibility for people
            with disabilities. We are continually improving the user experience
            for everyone and applying the relevant accessibility standards.
          </p>

          <div className={`p-6 rounded-xl mb-8 ${dk.isDark ? 'bg-gray-800' : 'bg-white'} shadow-sm`} data-id="element-4219" data-mp="17a04glr88xgi">
            <h2 className="text-xl font-bold mb-4" data-id="element-4220" data-mp="12c8cjrql1bcb">
              Measures to support accessibility
            </h2>
            <p className="mb-4" data-id="element-4221" data-mp="3brpbrmw7nsq6">
              LitLaunch takes the following measures to ensure accessibility:
            </p>
            <ul className="space-y-2" data-id="element-4222" data-mp="3lr6crr0ipift">
              {['Include accessibility as part of our internal mission statement.', 'Integrate accessibility into our procurement practices.', 'Provide continual accessibility training for our staff.', 'Assign clear accessibility targets and responsibilities.', 'Employ formal accessibility quality assurance methods.'].map((item, idx) => <li key={idx} className="flex items-start" data-id="element-4223" data-mp="dbwih52vdhil" data-mpi={idx}>
                  <CheckCircleIcon className="h-5 w-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-4224" data-mp="db4v2hjfeq3e" />
                  <span data-id="element-4225" data-mp="2a5rajsnp8q1d">{item}</span>
                </li>)}
            </ul>
          </div>

          <h3 data-id="element-4226" data-mp="2f3j935iunaej">Conformance Status</h3>
          <p data-id="element-4227" data-mp="272bm1ghd561r">
            The Web Content Accessibility Guidelines (WCAG) defines requirements
            for designers and developers to improve accessibility for people
            with disabilities. It defines three levels of conformance: Level A,
            Level AA, and Level AAA. LitLaunch is partially conformant with WCAG
            2.1 level AA. Partially conformant means that some parts of the
            content do not fully conform to the accessibility standard.
          </p>

          <h3 data-id="element-4228" data-mp="2l2megnybmsp1">Feedback</h3>
          <p data-id="element-4229" data-mp="2l34gk17o014v">
            We welcome your feedback on the accessibility of LitLaunch. Please
            let us know if you encounter accessibility barriers on LitLaunch:
          </p>
          <ul data-id="element-4230" data-mp="2urmgkg84e47g">
            <li data-id="element-4231" data-mp="2ut7ac3mm1j49">Phone: +1 (555) 123-4567</li>
            <li data-id="element-4232" data-mp="2uu8wb355zq0r">E-mail: accessibility@litlaunch.com</li>
            <li data-id="element-4233" data-mp="38sytsjvwbrpn">Visitor Address: 123 Book Street, Reading City, RC 12345</li>
          </ul>
          <p data-id="element-4234" data-mp="34r4zctcanjxx">We try to respond to feedback within 2 business days.</p>

          <h3 data-id="element-4235" data-mp="3nemdy523mw8i">Technical Specifications</h3>
          <p data-id="element-4236" data-mp="3nfxl8eur6m4d">
            Accessibility of LitLaunch relies on the following technologies to
            work with the particular combination of web browser and any
            assistive technologies or plugins installed on your computer:
          </p>
          <ul data-id="element-4237" data-mp="3jd0vm46sppqx">
            <li data-id="element-4238" data-mp="3jcj2hgffjrn8">HTML</li>
            <li data-id="element-4239" data-mp="3jbzh1pqkml4g">WAI-ARIA</li>
            <li data-id="element-4240" data-mp="3jb7ravjnnhm3">CSS</li>
            <li data-id="element-4241" data-mp="34o4smljlj2x6">JavaScript</li>
          </ul>
          <p data-id="element-4242" data-mp="34ncub2ym6r37">
            These technologies are relied upon for conformance with the
            accessibility standards used.
          </p>
        </div>
      </div>
    </div>;
};
export default Accessibility;